import { render, staticRenderFns } from "./Client_Requests.vue?vue&type=template&id=2d57d0ef"
import script from "./Client_Requests.vue?vue&type=script&lang=js"
export * from "./Client_Requests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports